import { render, staticRenderFns } from "./COrderSummary.vue?vue&type=template&id=3118efb1&"
import script from "./COrderSummary.vue?vue&type=script&lang=js&"
export * from "./COrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports